import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.minimal.css'
import styled from 'styled-components'

interface IHeaderContainerProperties {
    isIframe: boolean
    isNotVisible: boolean
}

export const HeaderStyled = styled.div`
    display: flex;
    align-content: space-between;
    justify-content: center;
    width: 100%;
`

export const HeaderContainer = styled.div<IHeaderContainerProperties>`
    display: ${({ isIframe }) => (isIframe ? 'none' : 'flex')};
    justify-content: flex-start;
    padding: 18px;
    background-color: ${properties => properties.theme.variables.colorBackground};
    border-bottom: 0.5px solid ${properties => properties.theme.variables.colorPrimary}33;
    visibility: ${({ isNotVisible }) => (isNotVisible ? 'hidden' : 'visible')};
`

export const HeaderMenu = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 1180px;
    margin: 0 auto;
`

export const HeaderMenuLinks = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
`
export const StyledToast = styled(ToastContainer).attrs({
    className: 'toast-container',
    toastClassName: 'toast',
    bodyClassName: 'body',
    progressClassName: 'progress',
})`
    .close-button {
        background-color: transparent;
        border: none;
        border: 1px solid ${properties => properties.theme.variables.colorDanger.primary};
        color: ${properties => properties.theme.variables.colorDanger.primary};
        font-family: ${properties => properties.theme.variables.fontFamily.description};
        padding: 8px;
        font-size: 16px;
        letter-spacing: 0px;
        line-height: 1.2;
        cursor: pointer;
        margin-right: 12px;
        position: absolute;
        right: 8px;
    }

    .toast {
        align-items: center;
        background: ${properties => properties.theme.variables.colorWarning.secondary};
        border: 1px solid ${properties => properties.theme.variables.colorWarning.primary};
        svg {
            fill: ${properties => properties.theme.variables.colorWarning.primary};
            padding-right: 8px;
        }
        font-family: ${properties => properties.theme.variables.fontFamily.description};
        color: ${properties => properties.theme.variables.colorDanger.primary};
        display: flex;
        justify-content: center;
        left: 0;
        margin: 0 auto;
        height: 55px;
        position: fixed;
        padding: 8px 20px;
        font-size: 16px;
        letter-spacing: 0px;
        line-height: 1.2;
        right: 0;
        width: 47%;
        z-index: 1;
        border-radius: 4px;
        max-width: 550px;
    }
`
